/* eslint-disable react/prop-types */
import React from 'react';
import google from './icons/google-play.png';
import apple from './icons/appstore.svg';

const AppStoreIcon = ({ store, height }) => {
  return (
    <>
      {store === 'google-play' ? (
        <img src={google} alt="Baixar na Play Store" height={height || 70} />
      ) : (
        <img src={apple} alt="Baixar na App Store" height={height || 48} />
      )}
    </>
  );
};

export default AppStoreIcon;
